
export const FETCH_USERS = 'fetchUsers'
export const FETCH_ROLES = 'fetchRoles'
export const FETCH_EQUIPMENTS = 'fetchEquipments'
export const FETCH_QUIZ_DETAILS =   'fetchQuizDetails'
export const FETCH_INDIVIDUAL_USER = 'fetchIndividualUser'
export const FETCH_INDIVIDUAL_EQUIPMENT =  'fetchIndividualEquipment'
export const FETCH_INDIVIDUAL_GROUP = 'fetchIndividualGroup'
export const FETCH_INDIVIDUAL_PAGE  =   'fetchIndividualPage'
export const FETCH_USER_DOCUMENTS  =   'fetchUserDocuments'
export const FETCH_INVOICES = 'fetchInvoices'
export const FETCH_GROUPS = 'fetchGroups'
export const FETCH_QUIZ_DATA = 'fetchQuizData'
export const FETCH_LANGUAGES    =   'fetchLanguages'
export const FETCH_PAGES = 'fetchPages'
export const CONTACT_QUERY   =   'contactQuery'
export const AUTO_RENEWAL_OFF = 'autoRenewalOff'
export const FETCH_STRIPE_SECRET_KEY = 'fetchStripeSecretKey'
export const SET_STRIPE_CARD = 'setStripeCard'
export const UPLOAD_USERS_CSV = 'uploadUsersCSV'
export const FORGOT_PASSWORD = 'forgotPassword'
export const FETCH_NAVIGATION_BAR_STATUS = 'fetchNavigationBarStatus'
export const UPDATE_USER_STATUS = 'updateUserStatus'
export const CHECK_TOKEN = 'checkToken'
export const UPDATE_PASSWORD = 'updatePassword'
export const ADD_USER = 'addUser'
export const ADD_GROUP = 'addGroup'
export const ADD_EQUIPMENT = 'addEquipment'
export const UPDATE_EQUIPMENT = 'updateEquipment'
export const GETTOKEN = 'getToken'
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const CHECK_AUTH = 'checkAuth'
export const DOWNLOAD_DOCUMENT  =   'downloadDocument'
export const SAVE_USER_SLIDE_ID = 'saveUserSlideID'
export const SAVE_USER_MODULE_PROGRESS = 'saveUserModuleProgress'
export const UPDATE_USER = 'updateUser'
export const DELETE_USER = 'deleteUser'
export const UPDATE_GROUP = 'updateGroup'
export const DELETE_GROUP = 'deleteGroup'
export const DELETE_EQUIPMENT = 'deleteEquipment'
export const DELETE_CARD = 'deleteCard'
export const FETCH_STRIPE_ALL_CARDS ='fetchStripeCards'
export const RESET_STATE    =   'resetState'
export const PAGES_RESET_STATE = "resetPagesState"
export const USERS_RESET_STATE  = 'resetUsersState'
export const STRIPE_RESET_STATE = "resetStripeState"
export const LANGUAGES_RESET_STATE  =   'resetLanguagesState'
export const EQUIPMENTS_RESET_STATE  =   'resetEquipmentsState'
export const GROUPS_RESET_STATE  =   'resetGroupsState'
export const ROLES_RESET_STATE  =   'resetRolesState'
export const GLOBALS_RESET_STATE   =   'resetGlobalsState'
export const FETCH_VOUCHERS = 'fetchVouchers'
export const FETCH_COURSES = 'fetchCourses'
export const FETCH_MODULES = 'fetchModules'
export const FETCH_INDIVIDUAL_MODULE = 'fetchIndividualModule'
export const COURSE_SUBSCRIBE = 'subscribeCourse'
export const FETCH_INDIVIDUAL_COURSE = 'fetchIndividualCourse'
export const FETCH_MODULE_PLAYER = 'fetchModulePlayer'
export const FETCH_GENERAL_DOCUMENTS    =   'fetchGeneralDocuments'
export const FETCH_PERSONAL_DOCUMENTS    =   'fetchPersonalDocuments'
export const DOWNLOAD_GENERAL_DOCUMENT  =   'downloadGeneralDocument'
export const DOWNLOAD_PERSONAL_DOCUMENT  =   'downloadPersonalDocument'
export const UPDATE_USER_DOCUMENT  =   'updateUserDocument'
export const DOWNLOAD_USER_DOCUMENT  =   'downloadUserDocument'
export const FETCH_USER_REGISTRATION_STATUS  =   'fetchUserRegistrationStatus'
export const USER_REGISTRATION  =   'userRegistration'
export const SAVE_USER_REGISTRATION_STATUS  =   'saveUserRegistrationStatus'
export const SAVE_UPDATE_INBOX_SETTINGS     =   'saveUpdateInboxSettings'
export const FETCH_INBOX_SETTINGS   =   'fetchInboxSettings'
export const CLEAR_INBOX_SETTINGS   =   'clearInboxSettings'
export const FETCH_DOCUMENT   =   'fetchDocument'
export const FETCH_LEARNING_SESSION_DATA  =   'fetchLearningSessionData'
export const FETCH_GROUP_USERS  =   'fetchGroupUsers'
export const FETCH_ADMIN_USERS  =   'fetchAdminUsers'
export const FETCH_COMPANY_SETTINGS  =   'fetchCompanySettings'
export const UPDATE_COMPANY_SETTINGS  =   'updateCompanySettings'
export const FETCH_DASHBOARD_DATA   =   'fetchDashboardData'
export const FETCH_DASHBOARD_LAST_COURSES   =   'fetchDashboardLastCourses'
export const FETCH_DASHBOARD_DOCUMENTS   =   'fetchDashboardDocuments'
export const FETCH_TIME_DATA   =   'fetchTimeData'
export const FETCH_DASHBOARD_QUIZ_DATA   =   'fetchQuizData'
export const FETCH_DASHBOARD_STATS_DATA   =   'fetchDashboardStatsData'
export const FETCH_DASHBOARD_COURSE_QUIZ_DATA = 'fetchdashboardcoursequizdata'
export const FETCH_DASHBOARD_MODULE_QUIZ_DATA = 'fetchdashboardmodulequizdata'
export const FETCH_DASHBOARD_COURSE_EVENT_DATA = 'fetchdashboardcourseeventdata'
export const FETCH_VIDEO_DATA = 'fetchVideoData'
export const VIDEO_RESET_STATE = 'resetVideoState'
export const FETCH_EQUIPMENT_GROUP_DATA = 'fetchEquipmentGroupData'
export const FETCH_EQUIPMENT_GROUP_INDIVIDUAL_DATA = 'fetchEquipmentGroupIndividualData'
export const ADD_EQUIPMENT_GROUP_DATA = 'addEquipmentGroupData'
export const UPDATE_EQUIPMENT_GROUP_DATA = 'updateEquipmentGroupData'
export const DELETE_EQUIPMENT_GROUP_DATA = 'deleteEquipmentGroupData'
export const FETCH_EQUIPMENT_TEMPLATE_DATA = 'fetchEquipmentTemplateData'
export const FETCH_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA = 'fetchEquipmentTemplateIndividualData'
export const ADD_EQUIPMENT_TEMPLATE_DATA = 'addEquipmentTemplateData'
export const UPDATE_EQUIPMENT_TEMPLATE_DATA = 'updateEquipmentTemplateData'
export const DELETE_EQUIPMENT_TEMPLATE_DATA = 'deleteEquipmentTemplateData'
export const DOWNLOAD_EQUIPMENT_TEMPLATE_DOCUMENT = 'downloadEquipmentTemplateDocument'
export const FETCH_INDIVIDUAL_PERSONAL_DOCUMENT = 'fetchIndividualPersonalDocument'
export const DELETE_PERSONAL_DOCUMENT = 'deletePersonalDocument'
export const UPDATE_PERSONAL_DOCUMENT = 'updatePersonalDocumentData'
export const ADD_PERSONAL_DOCUMENT = 'addPersonalDocument'
export const FETCH_TEST_GROUP = 'fetchTestGroup'
export const FETCH_INDIVIDUAL_TEST_GROUP = 'fetchIndividiualTestGroup'
export const ADD_TEST_GROUP = 'addTestGroup'
export const UPDATE_TEST_GROUP = 'updateTestGroup'
export const DELETE_TEST_GROUP = 'deleteTestGroup'
export const FETCH_TEST_CASE_TEMPLATE_DATA = 'fetchTestCaseTemplateData'
export const DOWNLOAD_TEST_CASE_TEMPLATE = 'downloadTestCaseTemplateData'
export const FETCH_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA = 'fetchTestCaseTemplateIndividualData'
export const ADD_TEST_CASE_TEMPLATE_DATA = 'addTestCaseTemplateData'
export const UPDATE_TEST_CASE_TEMPLATE_DATA = 'updateTestCaseTemplateData'
export const DELETE_TEST_CASE_TEMPLATE_DATA = 'deleteTestCaseTemplateData'
export const FETCH_CREATE_DOCUMENT = 'fetchCreateDocuments'
export const FETCH_EQUIPMENT_LABEL = 'fetchEquipmentLabel'
export const ADD_EQUIPMENT_LABEL_DATA = 'addEquipmentLabelData'
export const FETCH_TEST_CASE = 'fetchTestCase'
export const FETCH_INDIVIDUAL_TEST_CASE = 'fetchIndividualTestCase'
export const ADD_TEST_CASE = 'addTestCase'
export const UPDATE_TEST_CASE = 'updateTestCase'
export const EDIT_TEST_CASE = 'editTestCase'
export const DELETE_TEST_CASE = 'deleteTestCase'
export const FETCH_USER_CERTIFICATES = 'fetchUserCertificates'
export const FETCH_INDIVIDUAL_CERTIFICATE = 'fetchIndividualCertificates'
export const FETCH_DRAFT_COURSES = 'fetchDraftCourses'
export const BUY_VOUCHERS = 'buyVouchers'
export const LIST_COUPONS = 'listCoupons'
export const SEND_COUPONS = 'sendCoupons'
export const REVOKE_COUPON = 'revokeCoupon'
export const VALIDATE_COUPON = 'validateCoupon'
export const FETCH_TUTOR_PRODUCTS = 'fetchTutorProducts'
export const TUTOR_PRODUCT_SUBSCRIBE = 'subscribeTutorProduct'
export const FETCH_TUTOR_VOUCHERS = 'fetchTutorVouchers'
export const LIST_TUTOR_COUPONS = 'listTutorCoupons'
export const BUY_TUTOR_VOUCHERS = 'buyTutorVouchers'
export const SEND_TUTOR_COUPONS = 'sendTutorCoupons'
export const REVOKE_TUTOR_COUPON = 'revokeTutorCoupons'
export const VALIDATE_TUTOR_COUPON = 'validateTutorCoupon'
export const MICROSOFTLOGIN = 'microsoftLogin'
export const MICROSOFTCALLBACK = 'microsoftCallback'
export const FETCH_QUESTION = 'fetchQuestion'
export const FETCH_INDIVIDUAL_QUESTION = 'fetchIndividualQuestion'
export const ADD_QUESTION = 'addQuestion'
export const UPDATE_QUESTION = 'updateQuestion'
export const DELETE_QUESTION = 'deleteQuestion'
export const FETCH_QUESTION_TOPIC = 'fetchQuestionTopic'
export const ADD_QUESTION_TOPIC_DATA = 'addQuestionTopicData'
export const FETCH_ANSWERS = 'fetchAnswers'
export const FETCH_INDIVIDUAL_ANSWER = 'fetchIndividualAnswer'
export const ADD_ANSWER = 'addAnswer'
export const UPDATE_ANSWER = 'updateAnswer'
export const DELETE_ANSWER = 'deleteAnswer'
export const FETCH_QUIZ = 'fetchQuiz'
export const FETCH_INDIVIDUAL_QUIZ = 'fetchIndividualQuiz'
export const ADD_QUIZ = 'addQuiz'
export const UPDATE_QUIZ = 'updateQuiz'
export const DELETE_QUIZ = 'deleteQuiz'
export const FETCH_DAILY_QUIZ = 'fetchDailyQuiz'
export const FETCH_OPEN_QUIZZES = 'fetchOpenQuizzes'
export const FETCH_MODULE_QUIZ = 'fetchModuleQuiz'
export const ADD_USER_ANSWERS = 'addUserAnswers'
export const FETCH_DAILY_USER_ANSWERS = 'fetchDailyUserAnswers'
export const ADD_DAILY_USER_ANSWERS = 'addDailyUserAnswers'
export const FETCH_DASHBOARD_QUIZ_HISTORY_DATA = 'fetchDashboardQuizHistoryData'
export const UPDATE_CUR_USER_LANG = 'updateCurUserLang'
export const FETCH_PERMISSIONS = 'fetchPermissions'
export const FETCH_CUSTOM_ROLE = 'fetchCustomRole'
export const FETCH_INDIVIDUAL_CUSTOM_ROLE = 'fetchIndividualCustomRole'
export const ADD_CUSTOM_ROLE = 'addCustomRole'
export const UPDATE_CUSTOM_ROLE = 'updateCustomRole'
export const DELETE_CUSTOM_ROLE = 'deleteCustomRole'
export const FETCH_PERMISSION_LABELS = 'fetchPermissionLabels'
export const FETCH_USER_LOG = 'fetchUserLog'
export const FETCH_EMAIL_TYPES = 'fetchEmailTypes'
export const FETCH_MAIL_PLACEHOLDERS = 'fetchMailPlaceholders'
export const ADD_CUSTOM_MAIL_TEMPLATE = 'addCustomMailTemplate'
export const FETCH_EMAIL_TEMPLATES = 'fetchEmailTemplates'
export const FETCH_INDIVIDUAL_MAIL_TEMPLATE = 'fetchIndividualMailTemplate'
export const UPDATE_CUSTOM_MAIL_TEMPLATE = 'updateCustomMailTemplate'
export const SEND_TEST_MAIL = 'sendTestMail'
export const DELETE_EMAIL_TEMPLATE = 'deleteEmailTemplate'
export const FETCH_SCHEDULED_EMAIL_TEMPLATES = 'fetchScheduledEmailTemplates'
export const DELETE_SCHEDULED_EMAIL_TEMPLATE = 'deleteScheduledEmailTemplate'
export const FETCH_INDIVIDUAL_SCHEDULED_MAIL_TEMPLATE = 'fetchIndividualScheduledMailTemplate'
export const ADD_SCHEDULED_MAIL_TEMPLATE = 'addScheduledMailTemplate'
export const UPDATE_SCHEDULED_MAIL_TEMPLATE = 'updateScheduledMailTemplate'
export const SEND_SCHEDULED_TEST_MAIL = 'sendScheduledTestMail'
export const FETCH_TRIGGERED_EMAIL_TEMPLATES = 'fetchTriggeredEmailTemplates'
export const DELETE_TRIGGERED_EMAIL_TEMPLATE = 'deleteTriggeredEmailTemplate'
export const FETCH_INDIVIDUAL_TRIGGERED_MAIL_TEMPLATE = 'fetchIndividualTriggeredMailTemplate'
export const ADD_TRIGGERED_MAIL_TEMPLATE = 'addTriggeredMailTemplate'
export const UPDATE_TRIGGERED_MAIL_TEMPLATE = 'updateTriggeredMailTemplate'
export const SEND_TRIGGERED_TEST_MAIL = 'sendTriggeredTestMail'
export const FETCH_REMINDER_EMAIL_TEMPLATE = 'fetchReminderEmailTemplate'
export const FETCH_INDIVIDUAL_REMINDER_EMAIL_TEMPLATE = 'fetchIndividualReminderEmailTemplate'
export const DELETE_REMINDER_EMAIL_TEMPLATE ='deleteReminderEmailTemplate'
export const ADD_REMINDER_EMAIL_TEMPLATE ='addReminderEmailTemplate'
export const UPDATE_REMINDER_EMAIL_TEMPLATE ='updateReminderEmailTemplate'
export const SEND_REMINDER_TEST_MAIL ='sendReminderTestMail'
export const FETCH_COURSE_STATS = 'fetchCourseStats'
export const FETCH_GROUP_STATS = 'fetchGroupStats'
export const FETCH_USER_STATS = 'fetchUserStats'
export const FETCH_INBOX_MESSAGES = 'fetchInboxMessages'
export const FETCH_SENT_MESSAGES = 'fetchSentMessages'
export const FETCH_INDIVIDUAL_NOTIFICATION = 'fetchIndividualNotification'
export const MARK_NOTIFICATION_AS_READ = 'markNotificationAsRead'
export const ADD_ADDITIONAL_PAGE_RESOURCE = 'addAdditionalPageResource'
export const FETCH_ADDITIONAL_PAGES = 'fetchAdditionalPages'
export const FETCH_INDIVIDUAL_ADDITIONAL_PAGE = 'fetchIndividualAdditionalPages'
export const FETCH_PAGE_RESOURCES = 'fetchPageResource'
export const DELETE_PAGE_RESOURCE = 'deletePageResource'
export const ADD_COMPANY_PAGE = 'addCompanyPage'
export const UPDATE_COMPANY_PAGE = 'updateCompanyPage'
export const FETCH_RESOURCE_PAGES = 'fetchresourcePages'
export const DELETE_ADDITIONAL_PAGE = 'fetchAdditionalPage'
export const FETCH_ADDITIONAL_PAGES_ON_SIDE_MENU = 'fetchAdditionalPagesOnSideMenu'

export const FETCH_SURVEY = 'fetchSurvey'
export const FETCH_INDIVIDUAL_SURVEY = 'fetchIndividualSurvey'
export const ADD_SURVEY = 'addSurvey'
export const UPDATE_SURVEY = 'updateSurvey'
export const DELETE_SURVEY = 'deleteSurvey'
export const FETCH_DAILY_SURVEY = 'fetchDailySurvey'
export const FETCH_OPEN_SURVEYS = 'fetchOpenSurvey'
export const SURVEY_RESET_STATE = 'resetSurveyState'
export const ADD_SURVEY_USER_ANSWERS = 'addSurveyUserAnswers'

export const FETCH_TEST_EXAM = 'fetchTestExam'
export const FETCH_INDIVIDUAL_TEST_EXAM = 'fetchIndividualTestExam'
export const TEST_EXAM_RESET_STATE = 'resetTestExamState'
export const ADD_TEST_EXAM_USER_ANSWERS = 'addTestExamUserAnswers'
export const FETCH_DETAILED_INDIVIDUAL_TEST_RESULTS = 'fetchDetailedIndividualTestResults'
export const FETCH_ALL_TESTS = 'fetchAllTests'
export const FETCH_DETAILED_INDIVIDUAL_EXAM_RESULTS = 'fetchDetailedIndividualExamResults'
export const FETCH_ALL_EXAMS = 'fetchAllExams'

export const FETCH_EXERCISES = 'fetchExercises'
export const FETCH_INDIVIDUAL_EXERCISE = 'fetchIndividualExercises'
export const FETCH_ALL_EXERCISES = 'fetchAllExercises'
export const EXERCISE_RESET_STATE = 'resetExerciseState'
export const DOWNLOAD_EXERCISE_TEMPLATE = 'downloadExerciseTemplate'
export const ADD_EXERCISE_USER_ANSWERS = 'addExerciseUserAnswers'
export const FETCH_USER_UPLOADED_EXERCISE_ANSWERS = 'fetchUserUploadedExerciseAnswers'
export const UPDATE_EXERCISE_USER_ANSWERS_GRADE = 'updateExerciseUserAnswersGrade'
export const FETCH_ALL_AVAILABLE_EXERCISES = 'fetchAllAvailableExercises'

export const FETCH_CALENDARS = 'fetchCalendars'
export const FETCH_CALENDAR_EVENTS = 'fetchCalendarEvents'
export const FETCH_ALL_CALENDAR_EVENTS = 'fetchAllCalendarEvents'
export const JOIN_CALENDAR_EVENT = 'JoinCalendarEvent'
export const UNSUBSCRIBE_CALENDAR_EVENT = 'UnsubscribeCalendarEvent'
export const ADD_ATTENDEE_LIMIT = 'AddAttendeeLimit'
export const FETCH_PAST_EVENTS = 'FetchPastEvents'
export const SAVE_UPDATE_ATTENDEEE_EVENT = 'SaveUpdateAttendeeEvent'


